/** @format */

import React from 'react';
import ReactDOMClient from 'react-dom/client';
import { AppdirAdminApp } from 'fe-appdir-admin-app';
import axios from 'fe-axios';
import { getCookie } from 'fe-appdir-admin-app/src/__utils__';

// uncomment console statements to debug for now
//
// console logs aren't allowed due to linting and fe-lib-logging uses hootbus to push logs to sumo, which doesn't work
// because this isn't dashboard so there's no hootbus.
//
// eventual solution is probably push errors to sentry

// Include CSRF Token for each axios call
axios.interceptors.request.use(
  (config) => {
    const token = getCookie('__hscsrfid');
    config.headers['Csrf-Token'] = token ? token : null;
    return config;
  },
  (error) => Promise.reject(error)
);

// this event is received from aperture/hydra, you can see the config here:
//   https://github.hootops.com/Platform/hydra/blob/9b21ed3bbdc3fd24c83520a6631a7cf35ab746c0/configs/staging/config.yml#L46

function receiveMessage(event) {
  try {
    const json = JSON.parse(event.data);

    // success in this context means that
    //   if true, you are logged in
    //   if false, you are not logged in
    //
    // no authz has been determined at this point, though the user should have a jwt token from aperture.
    if (!json.success) {
      window.location.href = '/login?redirect=/admin';
      return;
    }

    // authz is handled by this app dir endpoint:
    //   https://github.hootops.com/Platform/service-app-dir/blob/master/service/src/main/scala/com/hootsuite/service/appdirectory/controllers/Admin.scala#L44
    //
    // it inspects a jwt token from aperture to determine if you're an admin or not.
    //
    // if you look at the code, it's supposed to return 403 but in practice it returns 404. no idea why that is yet.
    axios
      .get('/service/app-directory/admin', {
        // app dir returns 204 instead of 200 on success but all all 2xx codes are supposed to be successful, so i'm
        // going to save us some future grief when we change the 204 to a 200 in 5 years
        validateStatus: function (status) {
          return status >= 200 && status <= 299;
        },
      })
      .then((data) => {
        if (data.status !== 204) {
          // console.warn(`expected status code 204 but received code ${data.success}`);
        }
        const root = ReactDOMClient.createRoot(document.getElementById('root'));
        root.render(<AppdirAdminApp />);
      })
      .catch((error) => {
        // const response = error.response;
        // console.error("failed to validate app directory admin status", response);

        let renderErr = null;
        switch (error.response.status) {
          case 403:
            renderErr = 'This means you are not an app directory admin.';
            break;
          case 404:
            renderErr =
              'Most likely, this means you are not an app directory admin';
            break;
        }

        if (renderErr == null) {
          renderErr = '';
        }

        const root = ReactDOMClient.createRoot(document.getElementById('root'));
        root.render(
          <div>
            <p>Error, status code: {error.response.status}</p>
            <p>{renderErr}</p>
          </div>
        );
      });
  } catch (error) {
    // previously this swallowed everything. this was the previous comment here
    //   > Do nothing for now.
    //   > This will silence json errors on every message event
    //
    // due to linting, it still swallows everything, but we can maybe push to sentry in the future
    // console.warn(error);
  }
}

function ApertureSSO(options) {
  this.domain = options.domain;
  this.timeout = options.timeout || 5000;
  this.callback = options.callback || receiveMessage;
  this.iframe = null;
  if (typeof this.callback !== 'function') {
    throw new Error('options.callback must be a function');
  }
}

ApertureSSO.prototype.init = function () {
  this.iframe = window.document.createElement('iframe');
  this.iframe.style.display = 'none';
  this.iframe.src = this.domain;
  window.document.body.appendChild(this.iframe);
  window.addEventListener('message', this.callback, false);
};

export function checkLogin() {
  new ApertureSSO({
    domain: window.location.origin + '/login?response_mode=web_message',
  }).init();
}
